<template>
  <div class="faq">
    <SectionTitle>Perguntas frequentes</SectionTitle>
    <v-row>
      <v-col
        lg="8"
        md="12"
        sm="12"
      >
        <v-expansion-panels
          v-model="panel"
          multiple
          class="mt-8"
        >
          <v-expansion-panel
            v-for="(item, i) in items || faq"
            :key="i"
            :aria-labelledby="`faq-header-${i}`"
            :id="`faq-panel-${i}`"
            role="region"
            class="expansion-panel mt-2"
          >
            <v-expansion-panel-header
              :id="`faq-header-${i}`"
              role="button"
              :aria-controls="`faq-panel-${i}`"
              :aria-expanded="panel.includes(i) ? 'true' : 'false'"
            >
              {{ item.title }}
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              {{ item.text }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col
        lg="4"
        md="12"
        sm="12"
      >
        <div class="support mt-10">
          <v-icon class="whatsapp-icon">mdi-whatsapp</v-icon>
          <h2>Conte com um suporte que não te deixa na mão</h2>
          <p>
            Atendimento humanizado pelo WhatsApp, todos os dias das 08h:00 às 22h:00.
          </p>
          <CtaButton v-if="showPrice">Contratar agora</CtaButton>
          <CtaButton v-else>Falar com Atendente</CtaButton>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import SectionTitle from "@/components/SectionTitle.vue";
  import CtaButton from "@/components/CtaButton.vue";
  import faqDelivery from '@/seo/faq-delivery';
  import { mapState } from 'vuex';

  export default {
    name: "Faq",

    components: {
      SectionTitle,
      CtaButton,
    },

    props: {
      items: {
        type: Array,
        default: null,
      },
    },

    data: () => ({
      panel: [0, 1, 2, 3, 4, 5],
      faq: faqDelivery,
    }),

    computed: {
      ...mapState([
        'plan',
      ]),

      showPrice() {
        return this.plan.price > 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .v-expansion-panel-header {
    font-weight: bold;
    color: var(--text-primary);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .v-expansion-panel-content {
    color: var(--text-muted);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .expansion-panel {
    border-radius: 12px !important;
    border: 1px solid var(--card-border);
    background: var(--card-bg);
    width: 90%;
  }

  .support {
    border: 1px solid var(--card-border);
    background: var(--card-bg);
    padding: 24px;
    border-radius: 12px;
    color: var(--text-primary);
    h2 {
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 8px;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      color: var(--text-muted);
      margin-bottom: 0px;
    }
  }
  .whatsapp-icon {
    font-size: 48px;
    margin-bottom: 8px;
  }
</style>
